import React from 'react';
import FlowPerStrikeChart from './FlowPerStrikeChart';
import FlowMetricSelector from './FlowMetricSelector';
import { FlowPerStrikePoint, FlowMetricKey, StockDataPoint } from '../types/StockData';

interface FlowPerStrikeTabProps {
  flowPerStrikeData: FlowPerStrikePoint[];
  flowPerStrikeLoading: boolean;
  selectedFlowMetric: FlowMetricKey;
  onFlowMetricChange: (metric: FlowMetricKey) => void;
  selectedDataPoint: StockDataPoint | null;
  data: StockDataPoint[];
}

const FlowPerStrikeTab: React.FC<FlowPerStrikeTabProps> = ({
  flowPerStrikeData,
  flowPerStrikeLoading,
  selectedFlowMetric,
  onFlowMetricChange,
  selectedDataPoint,
  data
}) => {
  if (flowPerStrikeLoading) {
    return (
      <div className="text-center py-4 text-gray-500">
        Loading flow per strike data...
      </div>
    );
  }

  if (flowPerStrikeData.length === 0) {
    return (
      <div className="text-center py-4 text-gray-500">
        No flow per strike data available
      </div>
    );
  }

  const currentPrice = selectedDataPoint?.price || data[data.length - 1]?.price || 180;

  return (
    <div className="space-y-4">
      <FlowMetricSelector
        selectedMetric={selectedFlowMetric}
        onMetricChange={onFlowMetricChange}
      />
      <FlowPerStrikeChart
        data={flowPerStrikeData}
        selectedMetric={selectedFlowMetric}
        currentPrice={currentPrice}
      />
    </div>
  );
};

export default FlowPerStrikeTab;
